import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { ReactComponent as CartIcon } from 'app/assets/img/cart-icon.svg';
import { selectLengthCart } from 'app/pages/Cart/slice/selectors';
import { selectTranslations } from 'app/pages/App/slice/selectors';

const Cart: React.FC = () => {
  const history = useHistory();
  const lengthCart = useSelector(selectLengthCart);

  const onGoToCart = () => history.push('/cart');

  return (
    <Container onClick={onGoToCart}>
      <div style={{ position: 'relative', top: '3px', left: '-3px' }}>
        <CartIcon />
        <Number
          style={{
            width: `${lengthCart}`.length * 10,
            height: `${lengthCart}`.length * 10,
          }}
        >
          {lengthCart}
        </Number>
      </div>
    </Container>
  );
};

export default Cart;

export const NeedToPayment: React.FC<{ style?: CSSProperties }> = ({
  style,
}) => {
  const translations = useSelector(selectTranslations);

  return (
    <div
      style={{
        background: '#E921271A',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2.5px 31.5px',
        color: '#E92127',
        fontSize: 12,
        borderRadius: 40,
        ...style,
      }}
    >
      {translations ? translations['b2c.txt.needToPay'] : ''}
    </div>
  );
};

const Container = styled.div`
  min-width: 57px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-image: linear-gradient(to right, #f06f24, #f8b117);
  cursor: pointer;
`;

const Number = styled.div`
  position: absolute;
  border-radius: 50%;
  background: #e92127;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: calc(100% - 12px);
  left: calc(100% - 8px);
  padding: 8px;
`;
